<template>
   <b-modal :id="id" ref="negativeStatementInfoModal" size="md" ok-only
            :title="`Declaration of Origin For Article: ${article.name}`">

      <b-container class="text-left">

         <b-row>
            <b-col v-if="submitSuccess">
               <p><i class="fas fa-check-circle text-success"></i>We will process your request as quickly as
                  possible.</p>
            </b-col>
            <b-col v-else>
               <table class="table article-sheet">
                  <thead>
                  <tr>
                     <th style="border: none;"></th>
                     <th style="border: none;"></th>
                     <th style="border: none;">Declaration of ORIGIN</th>
                     <th style="border: none;">Long term declaration</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                     <td >
                        Origin of ALL components from EU
                     </td>
                     <td style="border-right: 1px solid #dee2e6;">
                        <span v-if="originOfAIGoods">
                          <i style="color:green" class="fa fa-check-circle"></i>
                        </span>
                        <span v-else>
                          <i style="color:red" class="fa fa-times-circle"></i>
                        </span>
                     </td>
                     <td rowspan="2" style="background-color: #f5f5f5;" class="px-2">
                        Download declaration <a @click.stop="openNegativeStatement()">here</a>
                     </td>
                     <td rowspan="2" style="border-left: 1px solid #dee2e6; background-color: #f5f5f5;" class="px-2">
                        <span v-if="originOfAIGoods && goodsBelongToAI">
                           please <a @click.stop="openConcact()">contact our team</a>, if a long term declaration with preferene can be provided for this item                        </span>
                        <span v-else-if="!originOfAIGoods && !goodsBelongToAI">
                          NO long term declaration can be provided for this item
                        </span>
                        <span v-else-if="originOfAIGoods && !goodsBelongToAI">
                          As HS code of this item does not belong to chapter <span class="text-nowrap">50-63</span>, NO long term declaration with preferention origin is required at your side. For further assistance, pls <a @click.stop="openConcact()">contact our team</a>
                        </span>
                        <span v-else>
NO long term declaration can be provided for this item
                        </span>
                     </td>
                  </tr>
                  <tr>
                     <td>
                        Goods belong to chapter <span class="text-nowrap">50-63</span>
                     </td>
                     <td style="border-right: 1px solid #dee2e6;">
                        <span v-if="goodsBelongToAI">
                          <i style="color:green" class="fa fa-check-circle"></i>
                        </span>
                        <span v-else>
                          <i style="color:red" class="fa fa-times-circle"></i>
                        </span>
                     </td>
                     <td>

                     </td>
                     <td>

                     </td>
                  </tr>
                  </tbody>
               </table>
            </b-col>
         </b-row>


      </b-container>
   </b-modal>
</template>
<script>

import ArticleApi from "@shared/_api/article";

let now = new Date();


function initialData() {
   return {
      submitSuccess: false,
      submitProcessing: false,
      submitError: null,
      formData: {
         from: now,
         to: null
      }
   }
}

export default {
   name: 'negative-statement-info-modal',
   props: {
      id: String,
      article: Object,
      category: Object,
      articleDetails: Object
   },
   data() {
      return {
         ...initialData()
      };
   },
   methods: {
      openConcact() {
         this.$refs.negativeStatementInfoModal.hide();
         this.$emit('contact');
      },
      openNegativeStatement() {
         this.$refs.negativeStatementInfoModal.hide();
         this.$emit('negative');
      },
      show() {
         this.$refs.negativeStatementInfoModal.show()
      },
      resetData() {

         this.$validator.reset().finally(() => {
            Object.assign(this.$data, initialData());
         });
      },
   },
   computed: {
      originOfAIGoods: function () {
         let countriesOfEurope = ["Italy", "Germany"];

         return (this.articleDetails && countriesOfEurope.includes(this.articleDetails.countryOfOrigin));
      },
      goodsBelongToAI: function () {

         return this.articleDetails && (Number(this.articleDetails.tarifCode.substring(0, 2)) > 49
             && Number(this.articleDetails.tarifCode.substring(0, 2)) < 64);
      }
   }
}
</script>